import { ErrorCode, FillAppError } from "./FillAppError";

export async function fetchWithErrorHandlers(
  input: RequestInfo | URL,
  init?: RequestInit
) {
  const response = await fetch(input, init);

  if (!response.ok) {
    const { code, message, cause } = await response.json();
    if (code && (cause || message)) {
      throw new FillAppError(code as ErrorCode, cause || message);
    }
    throw new FillAppError(
      "internal_server:chat",
      "An internal error occurred with the chat service."
    );
  }

  return response;
}
